import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { documentsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import "../../styles/components/Documents.scss";
import { storeFoldersActions } from "actions/storeFoldersActions";
import { withTranslation } from "react-i18next";

class StoreFolderEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let store_folder = {
			name: "",
		};

		let isEdit = false;

		if (props.store_folder) {
			store_folder = props.store_folder;

			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			store_folder,
		};
	}

	handleChange = (event) => {
		const { store_folder } = this.state;
		let value = event.target.value;

		this.setState({
			store_folder: {
				...store_folder,
				[event.target.id]: value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		const props = this.props;
		const { store_folder } = this.state;

		this.setState({ isLoading: true });

		try {
			// if edit => update; else => new
			if (this.state.isEdit) {
				await documentsService.updateStoreFolder(store_folder.id, store_folder);
			} else {
				await documentsService.createStoreFolder(store_folder);
			}

			this.setState({ isLoading: false, errors: {} });
			toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
			this.props.getStoreFolders();
			props.handleClose();
		} catch (error) {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(error),
			});
		}
	};

	render() {
		const { store_folder, errors, isEdit } = this.state;
		const { t } = this.props;

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="name">
						<FormLabel>{t("documents.folder.nameColumn")}</FormLabel>
						<FormControl
							type="text"
							value={store_folder.name}
							onChange={this.handleChange}
							placeholder={t("documents.folder.name")}
							isInvalid={this.checkValidField("name")}
						/>
						<FormControl.Feedback type="invalid">
							{errors.name}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t("common.save")}
						loadingText={t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.storeFoldersReducer,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getStoreFolders: () => dispatch(storeFoldersActions.getStoreFolders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StoreFolderEdit));
